
// import { useGetShippersSelectQuery } from "../../../../../newapi/shipper/shipperSlice";
import CloseIcon from '@mui/icons-material/Close';
import { Box, ButtonBase, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { DropdownBase, ShDropdownSearchQuery } from '../../theme/dropdowns/Dropdown';
import Text from '../../theme/text/Text';
// import { conditionKeys, conditions, condtionLineKeys, dropdownKeys, getMobileCondition, getShipperColorSettings, getStreamRuleKey } from "./ConditionSettings";

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../theme';
import TextInput from '../../theme/inputs/TextInput';
import { getMobileCondition, getConditionKey, textValueTypes, numberValueTypes, dropdownValueTypes, getListOptions, booleanValueTypes, searchableListValueTypes } from './ConditionSettings';
import { useGetConditionValuesQuery } from '../../../newapi/global/stream/streamSlice';
import SHQuickAction from '../../theme/Modal/SHQuickAction';
import Subheading from '../../theme/text/Subheading';
import { CRValueMultiSelect } from './CRValueMultiSelect';
import { CRValueSingleSelect } from './CRValueSingleSelect';
import { CRValueInput } from './CRValueInput';
import ShSwitch from '../../theme/inputs/ShSwitch';
import { condition_object_type } from '../../../utils/staticEnums';
import { useGetProductsSelectQuery } from '../../../newapi/warehouse/productSlice';

const ConditionRule = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [windowSize, setWindowSize] = useState(window.innerWidth);
    const handleResize = (event) => {
        setWindowSize(window.innerWidth);
    }
 
    const nominatorListValues = ["isinselection", "isnotinselection"];

    const { data: conditionValues, isLoading: conditionValuesLoading } = useGetConditionValuesQuery();
    const [conditionValueSelect, setConditionValueSelect] = useState([]);


    // console.log("conditionValueSelect",conditionValueSelect);
    useEffect(() => {
        if(conditionValues) {
            setConditionValueSelect(
                conditionValues.conditions.map(value => {
                    const name = value.objectType && [condition_object_type.ORDERFIELD, condition_object_type.PRODUCTFIELD].includes(value.objectType) ? value.key  // Dynamic field                    // no translation prefix for dynamic
                        : t(`condition_${value.key}`); // Static field

                    let objectType = null;
                    if (value.objectType === condition_object_type.ORDERFIELD) {
                        objectType = { objectType: condition_object_type.ORDERFIELD };
                    } else if (value.objectType === condition_object_type.PRODUCTFIELD) {
                        objectType = { objectType: condition_object_type.PRODUCTFIELD };
                    }

                    return {
                        name: name,
                        key: value.key,
                        ...(objectType ? objectType : {}) 
                    }
                    
                })
            );

            if (props.conditions) {
                setConditionsFromLoad();
            }
        }
    }, [conditionValues]);

    // Fallback for reload tab, conditions are not loaded in time
    useEffect(() => {
        if (props.conditions.length > 0 && !props.conditions[0]?.valueType && conditionValues) {
            setConditionsFromLoad();
        }
    }, [props.conditions]);

    // console.log("props.listOptions",props.listOptions);
     const getObjects = (ruleline,t) => {
         return getListOptions(ruleline?.valueType, props, t, true, ruleline?.listValues);
    }

    const setConditionsFromLoad = () => {
        const conditionsCopy = props.conditions.map(condition => {
            // Get nominator options, value type, and listValues for the new key
            const conditionFollowUpOptions = getConditionFollowUpOptions(condition.key);

            // Create a new object with all properties
            return {
                ...condition,
                nominatorOptions: conditionFollowUpOptions.nominatorOptions,
                valueType: conditionFollowUpOptions?.valueType,
                listValues: conditionFollowUpOptions?.listValues
            };
        });

        props.setCondtions(conditionsCopy);
    }

    const getConditionFollowUpOptions = (key) => {
        const condition = conditionValues?.conditions?.find(value => value.key === key);
        return {
            nominatorOptions: condition?.values ?? [],
            valueType: condition?.valueType ?? "string",
            listValues: condition?.listValues ?? []
        }
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);

    const updateStreamRuleLine = (lineIndex, newRuleLine) => {
        props.setCondtions(currentStreamRules => {
            const updatedStreamRules = [...currentStreamRules];

            updatedStreamRules[lineIndex] = {...updatedStreamRules[lineIndex], ...newRuleLine};

            return updatedStreamRules; // Return the updated array
        });
    };

    const addStreamRuleLine = () => {
        props.setCondtions(currentStreamRules => {
            const updatedStreamRules = [...currentStreamRules];
            updatedStreamRules.push({
                key: -1,
                nominator: "equalto",
                value: -1
            })
            
            return updatedStreamRules;
        });
    };

    const removeStreamRuleLine = (lineIndex) => {
        props.setCondtions(currentStreamRules => {
            let updatedStreamRules = [...currentStreamRules];
            
            updatedStreamRules.splice(lineIndex,1);
    
            return updatedStreamRules;
        });
    }

    const selectRuleLineKey = (selectedKey, index) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine
        ruleLine.key = conditionValueSelect[selectedKey].key;

        // Get nominator options, value type, and listValues for the new key
        const conditionFollowUpOptions = getConditionFollowUpOptions(ruleLine.key);

        // Set nominator options for dropdown
        ruleLine.nominatorOptions = conditionFollowUpOptions.nominatorOptions;

        // Set value type for input element key
        // Possible values:
        // string, number, date, time, country_list, day_with_additional_list, relation_list, warehouse_list, warehouse_location_list, list
        ruleLine.valueType = conditionFollowUpOptions.valueType;

        // Set listValues for list type productfields
        ruleLine.listValues = conditionFollowUpOptions.listValues;

        ruleLine.nominator = ruleLine.nominatorOptions[0];
        if (conditionValueSelect[selectedKey]?.objectType === condition_object_type.ORDERFIELD) {
            ruleLine.objectType = condition_object_type.ORDERFIELD;
        } else if (conditionValueSelect[selectedKey]?.objectType === condition_object_type.PRODUCTFIELD) {
            ruleLine.objectType = condition_object_type.PRODUCTFIELD;
        } else {
            delete ruleLine.objectType;
        }

        if (textValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = "";
        } else if (booleanValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = false;
        } else if (numberValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = 0;
        } else if (dropdownValueTypes.includes(ruleLine.valueType)) {
            if (nominatorListValues.includes(ruleLine.nominator)) {
                ruleLine.value = [];
            } else {
                ruleLine.value = -1;
            }
        } else if (searchableListValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = [];
            ruleLine.fullOptionList = [];
        }

        // Update the stream rule in the parent component's state
        updateStreamRuleLine(index, ruleLine);
    };

    const selectRuleLineCondition = (selectedNominator, index) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine.
        const oldNominator = ruleLine.nominator;
        const newNominator = ruleLine.nominatorOptions[selectedNominator];
        ruleLine.nominator = newNominator;

        // Reset value when switching between single-select and multi-select nominators
        if (dropdownValueTypes.includes(ruleLine.valueType)) {
            const wasMultiSelect = nominatorListValues.includes(oldNominator);
            const isMultiSelect = nominatorListValues.includes(newNominator);
            if (wasMultiSelect !== isMultiSelect) {
                ruleLine.value = isMultiSelect ? [] : -1;
            }
        }

        updateStreamRuleLine(index, ruleLine);
    };

    const selectRuleLineValue = (selectedValue, index) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine.
        ruleLine.value = selectedValue;

        updateStreamRuleLine(index, ruleLine);
    };

    const selectSearchableListValue = (selectedValue, index,option) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine.
        ruleLine.value = selectedValue;

        const optionIndex = ruleLine.fullOptionList.findIndex(
            fo => fo.id === option.id
        );

        if (optionIndex === -1) {
            ruleLine.fullOptionList = [...ruleLine.fullOptionList, option];
        } else {
            ruleLine.fullOptionList = ruleLine.fullOptionList.filter(
                fo => fo.id !== option.id
            );
        }

        updateStreamRuleLine(index, ruleLine);
    };

    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                gap:1,
                width:1
            }}
        >
             <Box
                onClick={addStreamRuleLine}
                sx={{
                    height:40,
                    display:"flex",
                    justifyContent:"center",
                    alignItems:"center",
                    borderRadius:5,
                    background: colors.grey[400],
                    cursor:"pointer",
                    "&:hover" : {
                        background: colors.bg["menu"],
                        
                    }
                }}
            >
                <Text color={tokens("dark").txt["primary"]} semibold>Nieuwe voorwaarde</Text>
            </Box>

            {props.conditions.map((ruleline,index) => (
                <Box key={index+"pcs"}>
                    <Box
                        key={index}
                        sx={{
                            position:'relative',
                            height:40,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            p:0.5,
                            // background:"#FFE9D6",
                            background:colors.grey[100],
                            borderRadius:5,
                        }}
                    >
                        {/* Colli */}
                        <DropdownBase
                            displayName={"name"} 
                            onChange={(selected) => selectRuleLineKey(selected,index)}
                            noSelection={t("choose_key")} 
                            options={conditionValueSelect}
                            useTranslation 
                            selected={conditionValueSelect.findIndex(value => value.key === ruleline.key)}
                            closeOnSelection
                            disallowDeselection
                            
                            searchOptions={{
                                enabled:true,
                                placeholder:t("search")
                            }}
                            // shComponent={<CustomComponent></CustomComponent>} // new
                        >
                            <Box
                                className={cx('',{
                                    'error': props.errorMap && props.errorMap[index] && props.errorMap[index].key,
                                })}
                                sx={{
                                    width:120,
                                    display:"flex",
                                    justifyContent:"center",
                                    alignItems:"center",
                                    height:32,
                                    borderRadius:4,
                                    "&:hover" : {
                                        background:colors.grey[200],
                                        cursor:"pointer",
                                    },
                                    "@media screen and (max-width: 768px)" : {
                                        // px:0.5,
                                    },
                                    "&.error" : {
                                        background:colors.red[100]
                                    }
                                }}
                            >
                                <Text noBreak>{conditionValueSelect?.find(value => value.key === ruleline.key) ? t(conditionValueSelect?.find(value => value.key === ruleline.key)?.name) : t("choose_condition")}</Text>
                            </Box>
                        </DropdownBase>

                        {!booleanValueTypes.includes(ruleline.valueType) &&
                            <DropdownBase
                                displayName={"name"} 
                                onChange={(selected) => selectRuleLineCondition(selected,index)}
                                noSelection={""} //Custom text when nothing is selected
                                options={ruleline.nominatorOptions ?? []} // array
                                useTranslation // conditions uses translation keys as the array,
                                selected={ruleline && conditionValues?.conditions?.find(value => value.key === ruleline.key)?.nominators?.findIndex(value => value === ruleline.nominator) ?
                                    conditionValues?.conditions?.find(value => value.key === ruleline.key)?.nominators?.findIndex(value => value === ruleline.nominator) : -1
                                }
                                
                                closeOnSelection
                                disallowDeselection
                            >
                                <Box
                                    sx={{
                                        position:'absolute',
                                        left:"50%",
                                        top:"50%",
                                        transform:"translate(-50%, -50%)",
                                        width:155,
                                        pl:2,
                                        pr:2,
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        height:32,
                                        borderRadius:4,
                                        "&:hover" : {
                                            background:colors.grey[200],
                                            cursor:"pointer",
                                        },
                                        "@media screen and (max-width: 768px)" : {
                                            position:"sticky",
                                            transform:"unset",
                                            top:'unset',
                                            left:'unset',
                                            width:"32px",
                                            p:0,
                                            ml:0,
                                            mr:0,
                                        }
                                    }}
                                >
                                    {windowSize > 768?
                                        typeof ruleline.nominator === 'Number' || ruleline.nominator === -1 ?
                                            <Text noBreak >{t('choose_condition')}</Text>
                                        :
                                            <Text noBreak bold>{t(ruleline.nominator)}</Text>
                                    :
                                        <Text bold>{getMobileCondition(ruleline.nominator)}</Text>
                                    }
                                </Box>
                            </DropdownBase>
                        }

                     
                        { textValueTypes.includes(ruleline.valueType) || numberValueTypes.includes(ruleline.valueType) ? (
                            <CRValueInput
                                ruleline={ruleline}
                                index={index}
                                selectRuleLineValue={selectRuleLineValue}
                                errorMap={props.errorMap}
                                colors={colors}
                            />
                        ) :
                        booleanValueTypes.includes(ruleline.valueType) ? (
                            <Box
                                sx={{
                                    display: "inline-flex",
                                    ml: "auto",

                                }}
                            >
                                <ShSwitch
                                    color={theme.palette.mode === "dark" ? "white" :"grey"}
                                    switchColor={theme.palette.mode === "dark" ? "#fff" : "#31415f"}
                                    checked={ruleline.value}
                                    onChange={(event) => selectRuleLineValue(event.target.checked,index)}
                                />
                            </Box>
                        ) :
                        searchableListValueTypes.includes(ruleline.valueType) ? (
                            <ShDropdownSearchQuery
                                name={ruleline.valueType}

                                displayName={"combined"}
                                onChange={(selected,option) => {
                                    selectSearchableListValue(selected,index,option);
                                    // handleChange("newWarehouseLocation",selected > -1 ?option : "");
                                    // setSelectedWarehouseLocationId(selected);
                                }}
                                selected={ruleline.value ?? [-1]}
                                multiple={true}
                                searchOptions={{
                                    placeholder:t("search")
                                }}
                                content={useGetProductsSelectQuery}
                            >

                                {({anchorEl,onClick}) => (
                                    <ButtonBase
                                        onClick={onClick}
                                        sx={{
                                            ml:"auto",
                                            display:"inline-flex",
                                            alignItems:"center",
                                            justifyContent:"center",
                                            background:colors.grey[100],
                                            height:32,
                                            minWidth:120,
                                            borderRadius:4,
                                            px:1.5,
                                            "&:hover" : {
                                                background:colors.grey[200],
                                                cursor:"pointer",
                                            },
                                            "@media screen and (max-width: 768px)" : {
                                                // ml:1,
                                            },
                                        }}
                                    >
                                        <Text noBreak>
                                            {ruleline.fullOptionList.length > 0 ? ruleline.fullOptionList.length > 1 ? 
                                            ruleline.fullOptionList.length + " " + t("selected") : ruleline.fullOptionList[0]?.combined : t("no_selection")}
                                            {/* {getListOptions(ruleline?.valueType, props.countries, t)?.find(value => value.id === ruleline.value)?.name} */}
                                        </Text>
                                    </ButtonBase>
                                )}
                            </ShDropdownSearchQuery>
                        ) :
                        nominatorListValues.includes(ruleline.nominator) ? (
                            <CRValueMultiSelect
                                ruleline={ruleline}
                                index={index}
                                selectRuleLineValue={selectRuleLineValue}
                                errorMap={props.errorMap}
                                colors={colors}
                                t={t}
                                conditionValueSelect={conditionValueSelect}
                                getObjects={getObjects}
                                getListOptions={getListOptions}
                            />
                        ) : (
                            <CRValueSingleSelect
                                ruleline={ruleline}
                                index={index}
                                selectRuleLineValue={selectRuleLineValue}
                                errorMap={props.errorMap}
                                colors={colors}
                                t={t}
                                getListOptions={getListOptions}
                                props={props}
                            />
                        )}


                        <Box
                            onClick={() => removeStreamRuleLine(index)}
                            sx={{
                                flexShrink:0,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center",
                                height:32,
                                width:32,
                                borderRadius:4,
                                ml:1,
                                mr:0.5,
                                color: colors.txt["secondary"],
                                "&:hover" : {
                                    // background:"#FFDBBD",
                                    background:colors.grey[200],
                                    cursor:"pointer",
                                }
                            }}
                        >
                            <CloseIcon fontSize='small'/>
                        </Box>

                    </Box>
                    {props.errorMap && props.errorMap[index] && (
                        <Box sx={{

                            position:'relative',
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"space-between",
                            p:0.5,
                            // background:"#FFE9D6",
                            borderRadius:5,
                        }}>
                            <Box
                                sx={{
                                    width:120,
                                    display:"flex",
                                    justifyContent:"center",
                                    alignItems:"center",
                                    borderRadius:4,
                                    "@media screen and (max-width: 768px)" : {
                                        px:1,
                                    }
                                }}
                            >
                                {props.errorMap[index] && props.errorMap[index].key && (
                                    <div style={{ color: 'red' }}>{t(props.errorMap[index].key)}</div>
                                )}
                                {/* {
                                    Object.keys(props.errorMap[index]).map((errorKey) => (
                                        <p key={errorKey}>{props.errorMap[index][errorKey]}</p>
                                    ))
                                } */}
                            </Box>

                            {/* Simulated nominator */}
                            <Box
                                sx={{
                                    position:'absolute',
                                    left:"50%",
                                    top:"50%",
                                    transform:"translate(-50%, -50%)",
                                    width:155,
                                    pl:2,
                                    pr:2,
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    borderRadius:4,
                                    "@media screen and (max-width: 768px)" : {
                                        position:"sticky",
                                        transform:"unset",
                                        top:'unset',
                                        left:'unset',
                                        width:"32px",
                                        p:0,
                                        ml:0,
                                        mr:0,
                                    }
                                }}
                            >
                                
                            </Box>

                            <Box
                                sx={{
                                    ml:"auto",
                                    // flex:1,
                                    // flexGrow:0,
                                    display:"inline-flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    width:120,
                                    px:1,
                                    borderRadius:4,
                                }}
                            >
                            {props.errorMap[index] && props.errorMap[index].value && (
                                <div style={{ color: 'red' }}>{t(props.errorMap[index].value)}</div>
                            )}
                            </Box>

                            {/* Simulated end btn */}
                            <Box
                                sx={{
                                    flexShrink:0,
                                    
                                    width:32,
                                    ml:1,
                                    mr:0.5,
                                }}
                            >
                            </Box>
                        </Box>
                    )}
                </Box>
            ))}
            
        </Box>
    );
}

export default ConditionRule;


export const ConditionRuleV2 = (props) => {
    // console.log(props.ruleline);
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [windowSize, setWindowSize] = useState(window.innerWidth);
    const handleResize = (event) => {
        setWindowSize(window.innerWidth);
    }
 
    const nominatorListValues = ["isinselection", "isnotinselection"];

     const getObjects = (ruleline,t) => {
         return getListOptions(ruleline?.valueType, props, t, true, ruleline?.listValues);
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        }
    }, []);

    const updateStreamRuleLine = (lineIndex, newRuleLine) => {
        props.setCondtions(currentStreamRules => {
            const updatedStreamRules = [...currentStreamRules];

            updatedStreamRules[lineIndex] = {...updatedStreamRules[lineIndex], ...newRuleLine};

            return updatedStreamRules; // Return the updated array
        });
    };

    const removeStreamRuleLine = (lineIndex) => {
        props.setCondtions(currentStreamRules => {
            let updatedStreamRules = [...currentStreamRules];

            updatedStreamRules.splice(lineIndex,1);

            return updatedStreamRules;
        });
    }

    const getConditionFollowUpOptions = (key) => {
        const condition = props.conditionValues?.conditions?.find(value => value.key === key);
        return {
            nominatorOptions: condition?.values ?? [],
            valueType: condition?.valueType ?? "string",
            listValues: condition?.listValues ?? []
        }
    }

    const selectRuleLineKey = (selectedKey, index) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine
        ruleLine.key = props.conditionValueSelect[selectedKey].key;

        // Get nominator options, value type, and listValues for the new key
        const conditionFollowUpOptions = getConditionFollowUpOptions(ruleLine.key);

        // Set nominator options for dropdown
        ruleLine.nominatorOptions = conditionFollowUpOptions.nominatorOptions;

        // Set value type for input element key
        // Possible values:
        // string, number, date, time, country_list, day_with_additional_list, relation_list, warehouse_list, warehouse_location_list, list
        ruleLine.valueType = conditionFollowUpOptions.valueType;

        // Set listValues for list type productfields
        ruleLine.listValues = conditionFollowUpOptions.listValues;

        ruleLine.nominator = ruleLine.nominatorOptions[0];
        if (props.conditionValueSelect[selectedKey]?.objectType === condition_object_type.ORDERFIELD) {
            ruleLine.objectType = condition_object_type.ORDERFIELD;
        } else if (props.conditionValueSelect[selectedKey]?.objectType === condition_object_type.PRODUCTFIELD) {
            ruleLine.objectType = condition_object_type.PRODUCTFIELD;
        } else {
            delete ruleLine.objectType;
        }

        if (textValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = "";
        } else if (numberValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = 0;
        } else if (booleanValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = false;
        } else if (dropdownValueTypes.includes(ruleLine.valueType)) {
            if (nominatorListValues.includes(ruleLine.nominator)) {
                ruleLine.value = [];
            } else {
                ruleLine.value = -1;
            }
        } else if (searchableListValueTypes.includes(ruleLine.valueType)) {
            ruleLine.value = [];
            ruleLine.fullOptionList = [];
        }

        // Update the stream rule in the parent component's state
        updateStreamRuleLine(index, ruleLine);
    };

    const selectRuleLineCondition = (selectedNominator, index) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine.
        const oldNominator = ruleLine.nominator;
        const newNominator = ruleLine.nominatorOptions[selectedNominator];
        ruleLine.nominator = newNominator;

        // Reset value when switching between single-select and multi-select nominators
        if (dropdownValueTypes.includes(ruleLine.valueType)) {
            const wasMultiSelect = nominatorListValues.includes(oldNominator);
            const isMultiSelect = nominatorListValues.includes(newNominator);
            if (wasMultiSelect !== isMultiSelect) {
                ruleLine.value = isMultiSelect ? [] : -1;
            }
        }

        updateStreamRuleLine(index, ruleLine);
    };

    const selectRuleLineValue = (selectedValue, index) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine.
        ruleLine.value = selectedValue;

        updateStreamRuleLine(index, ruleLine);
    };

    const selectSearchableListValue = (selectedValue, index,option) => {
        const ruleLine = { ...props.conditions[index] }; // Create a copy of the ruleLine.
        ruleLine.value = selectedValue;

        const optionIndex = ruleLine.fullOptionList.findIndex(
            fo => fo.id === option.id
        );

        if (optionIndex === -1) {
            ruleLine.fullOptionList = [...ruleLine.fullOptionList, option];
        } else {
            ruleLine.fullOptionList = ruleLine.fullOptionList.filter(
                fo => fo.id !== option.id
            );
        }

        updateStreamRuleLine(index, ruleLine);
    };

    return (

        <Box>
            <Box
                sx={{
                    position:'relative',
                    height:40,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    p:0.5,
                    // background:"#FFE9D6",
                    background:colors.grey[100],
                    borderRadius:5,
                }}
            >
                {/* key */}
                <DropdownBase
                    displayName={"name"} 
                    onChange={(selected) => selectRuleLineKey(selected,props.index)}
                    noSelection={t("choose_key")} 
                    options={props.conditionValueSelect}
                    useTranslation 
                    selected={props.conditionValueSelect?.findIndex(value => value.key === props.ruleline.key)}
                    closeOnSelection
                    disallowDeselection

                    searchOptions={{
                        enabled:true,
                        placeholder:t("search")
                    }}
                    // shComponent={<CustomComponent></CustomComponent>} // new
                >
                    <Box
                        className={cx('',{
                            'error': props.errorMap && props.errorMap[props.index] && props.errorMap[props.index].key,
                        })}
                        sx={{
                            width:120,
                            display:"flex",
                            justifyContent:"center",
                            alignItems:"center",
                            height:32,
                            borderRadius:4,
                            "&:hover" : {
                                background:colors.grey[200],
                                cursor:"pointer",
                            },
                            "@media screen and (max-width: 768px)" : {
                                // px:0.5,
                            },
                            "&.error" : {
                                background:colors.red[100]
                            }
                        }}
                    >
                        <Text noBreak>{props.conditionValueSelect?.find(value => value.key === props.ruleline.key) ? t(props.conditionValueSelect?.find(value => value.key === props.ruleline.key)?.name) : t("choose_condition")}</Text>
                    </Box>
                </DropdownBase>
                {!booleanValueTypes.includes(props.ruleline.valueType) &&
                    <DropdownBase
                        displayName={"name"} 
                        onChange={(selected) => selectRuleLineCondition(selected,props.index)}
                        noSelection={""} //Custom text when nothing is selected
                        options={props.ruleline.nominatorOptions ?? []} // array
                        useTranslation // conditions uses translation keys as the array,
                        selected={props.ruleline && props.conditionValues?.conditions?.find(value => value.key === props.ruleline.key)?.nominators?.findIndex(value => value === props.ruleline.nominator) ?
                            props.conditionValues?.conditions?.find(value => value.key === props.ruleline.key)?.nominators?.findIndex(value => value === props.ruleline.nominator) : -1
                        }
                        
                        closeOnSelection
                        disallowDeselection
                    >
                        <Box
                            sx={{
                                position:'absolute',
                                left:"50%",
                                top:"50%",
                                transform:"translate(-50%, -50%)",
                                width:155,
                                pl:2,
                                pr:2,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"center",
                                height:32,
                                borderRadius:4,
                                "&:hover" : {
                                    background:colors.grey[200],
                                    cursor:"pointer",
                                },
                                "@media screen and (max-width: 768px)" : {
                                    position:"sticky",
                                    transform:"unset",
                                    top:'unset',
                                    left:'unset',
                                    width:"32px",
                                    p:0,
                                    ml:0,
                                    mr:0,
                                }
                            }}
                        >
                            {windowSize > 768?
                                typeof props.ruleline.nominator === 'Number' || props.ruleline.nominator === -1 ?
                                    <Text noBreak >{t('choose_condition')}</Text>
                                :
                                    <Text noBreak bold>{t(props.ruleline.nominator)}</Text>
                            :
                                <Text bold>{getMobileCondition(props.ruleline.nominator)}</Text>
                            }
                        </Box>
                    </DropdownBase>
                }
                { textValueTypes.includes(props.ruleline.valueType) || numberValueTypes.includes(props.ruleline.valueType) ? (
                    <CRValueInput
                        ruleline={props.ruleline}
                        index={props.index}
                        selectRuleLineValue={selectRuleLineValue}
                        errorMap={props.errorMap}
                        colors={colors}
                    />
                ) :
                booleanValueTypes.includes(props.ruleline.valueType) ? (
                    <Box
                        sx={{
                            display: "inline-flex",
                            ml: "auto",

                        }}
                    >
                        <ShSwitch
                            color={theme.palette.mode === "dark" ? "white" :"grey"}
                            switchColor={theme.palette.mode === "dark" ? "#fff" : "#31415f"}
                            checked={props.ruleline.value}
                            onChange={(event) => selectRuleLineValue(event.target.checked,props.index)}
                        />
                    </Box>
                ) :
                searchableListValueTypes.includes(props.ruleline.valueType) ? (
                    <ShDropdownSearchQuery
                        name={props.ruleline.valueType}

                        displayName={"combined"}
                        onChange={(selected,option) => {
                            selectSearchableListValue(selected,props.index,option);
                            // handleChange("newWarehouseLocation",selected > -1 ?option : "");
                            // setSelectedWarehouseLocationId(selected);
                        }}
                        selected={props.ruleline.value ?? [-1]}
                        multiple={true}
                        searchOptions={{
                            placeholder:t("search")
                        }}
                        content={useGetProductsSelectQuery}
                    >

                        {({anchorEl,onClick}) => (
                            <ButtonBase
                                onClick={onClick}
                                sx={{
                                    ml:"auto",
                                    display:"inline-flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    background:colors.grey[100],
                                    height:32,
                                    minWidth:120,
                                    borderRadius:4,
                                    px:1.5,
                                    "&:hover" : {
                                        background:colors.grey[200],
                                        cursor:"pointer",
                                    },
                                    "@media screen and (max-width: 768px)" : {
                                        // ml:1,
                                    },
                                }}
                            >
                                <Text noBreak>
                                    {props.ruleline.fullOptionList.length > 0 ? props.ruleline.fullOptionList.length > 1 ? 
                                    props.ruleline.fullOptionList.length + " " + t("selected") : props.ruleline.fullOptionList[0]?.combined : t("no_selection")}
                                    {/* {getListOptions(ruleline?.valueType, props.countries, t)?.find(value => value.id === ruleline.value)?.name} */}
                                </Text>
                            </ButtonBase>
                        )}
                    </ShDropdownSearchQuery>
                ) :
                nominatorListValues.includes(props.ruleline.nominator) ? (
                    <CRValueMultiSelect
                        ruleline={props.ruleline}
                        index={props.index}
                        selectRuleLineValue={selectRuleLineValue}
                        errorMap={props.errorMap}
                        colors={colors}
                        t={t}
                        conditionValueSelect={props.conditionValueSelect}
                        getObjects={getObjects}
                        getListOptions={getListOptions}
                        props={props}
                    />
                ) : (
                    <CRValueSingleSelect
                        ruleline={props.ruleline}
                        index={props.index}
                        selectRuleLineValue={selectRuleLineValue}
                        errorMap={props.errorMap}
                        colors={colors}
                        t={t}
                        getListOptions={getListOptions}
                        props={props}
                    />
                )}


                <Box
                    onClick={() => removeStreamRuleLine(props.index)}
                    sx={{
                        flexShrink:0,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                        height:32,
                        width:32,
                        borderRadius:4,
                        ml:1,
                        mr:0.5,
                        color: colors.txt["secondary"],
                        "&:hover" : {
                            // background:"#FFDBBD",
                            background:colors.grey[200],
                            cursor:"pointer",
                        }
                    }}
                >
                    <CloseIcon fontSize='small'/>
                </Box>

            </Box>
            {props.errorMap && props.errorMap[props.index] && (
                <Box sx={{

                    position:'relative',
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    p:0.5,
                    // background:"#FFE9D6",
                    borderRadius:5,
                }}>
                    <Box
                        sx={{
                            width:120,
                            display:"flex",
                            justifyContent:"center",
                            alignItems:"center",
                            borderRadius:4,
                            "@media screen and (max-width: 768px)" : {
                                px:1,
                            }
                        }}
                    >
                        {props.errorMap[props.index] && props.errorMap[props.index].key && (
                            <div style={{ color: 'red' }}>{t(props.errorMap[props.index].key)}</div>
                        )}
                        {/* {
                            Object.keys(props.errorMap[index]).map((errorKey) => (
                                <p key={errorKey}>{props.errorMap[index][errorKey]}</p>
                            ))
                        } */}
                    </Box>

                    {/* Simulated nominator */}
                    <Box
                        sx={{
                            position:'absolute',
                            left:"50%",
                            top:"50%",
                            transform:"translate(-50%, -50%)",
                            width:155,
                            pl:2,
                            pr:2,
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            borderRadius:4,
                            "@media screen and (max-width: 768px)" : {
                                position:"sticky",
                                transform:"unset",
                                top:'unset',
                                left:'unset',
                                width:"32px",
                                p:0,
                                ml:0,
                                mr:0,
                            }
                        }}
                    >
                        
                    </Box>

                    <Box
                        sx={{
                            ml:"auto",
                            // flex:1,
                            // flexGrow:0,
                            display:"inline-flex",
                            alignItems:"center",
                            justifyContent:"center",
                            width:120,
                            px:1,
                            borderRadius:4,
                        }}
                    >
                    {props.errorMap[props.index] && props.errorMap[props.index].value && (
                        <div style={{ color: 'red' }}>{t(props.errorMap[props.index].value)}</div>
                    )}
                    </Box>

                    {/* Simulated end btn */}
                    <Box
                        sx={{
                            flexShrink:0,
                            
                            width:32,
                            ml:1,
                            mr:0.5,
                        }}
                    >
                    </Box>
                </Box>
            )}
        </Box>
            
    );
}
